import { render, staticRenderFns } from "./NomeGrupoField.vue?vue&type=template&id=30ad4f7a&scoped=true&"
import script from "./NomeGrupoField.vue?vue&type=script&lang=js&"
export * from "./NomeGrupoField.vue?vue&type=script&lang=js&"
import style0 from "./NomeGrupoField.vue?vue&type=style&index=0&id=30ad4f7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ad4f7a",
  null
  
)

export default component.exports